import { createI18n } from 'vue-i18n';
import enJson         from './en.json';
import frJson         from './fr.json';

const messages = {
  en : enJson,
  fr : frJson
};

const i18n = new createI18n({
  locale : 'en', // set locale
  messages // set locale messages
});

export default i18n;
